<template>
  <div class="text-center">
    <vtk-alert />
    <vtk-confirm />
    <vtk-loading />
    <vtk-prompt />
    <vtk-toast />
  </div>
</template>

<script>
import vtkAlert from "./alert";
import vtkConfirm from "./confirm";
import vtkLoading from "./loading";
import vtkPrompt from "./prompt";
import vtkToast from "./toast";
export default {
  name: "vtkMessage",
  components: {
    vtkAlert,
    vtkConfirm,
    vtkLoading,
    vtkPrompt,
    vtkToast,
  },
};
</script>